interface NotePreviewProps {
  note: string;
  isLoading: boolean;
  onNoteChange: (note: string) => void;
  isEditable: boolean;
}

export default function NotePreview({ note, isLoading, onNoteChange, isEditable }: NotePreviewProps) {
  if (isLoading) {
    return (
      <div className="section-card h-full flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-clinical-200 border-t-clinical-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Generating note...</p>
        </div>
      </div>
    );
  }

  if (!note) {
    return (
      <div className="section-card h-full flex items-center justify-center min-h-[400px] bg-gray-50">
        <div className="text-center text-gray-500">
          <svg className="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="text-lg font-medium">No Note Generated</p>
          <p className="text-sm mt-1">Fill out the form and click "Generate Note" to preview</p>
        </div>
      </div>
    );
  }

  return (
    <div className="section-card h-full">
      <div className="flex items-center justify-between mb-4">
        <h2 className="section-title mb-0 border-b-0 pb-0">Note Preview</h2>
        {isEditable && (
          <span className="text-xs text-clinical-600 bg-clinical-50 px-2 py-1 rounded">
            Editable
          </span>
        )}
      </div>

      {isEditable ? (
        <textarea
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          className="w-full h-[calc(100vh-300px)] min-h-[500px] font-mono text-sm p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-clinical-500 focus:border-transparent resize-none bg-white"
          spellCheck={false}
        />
      ) : (
        <pre className="w-full h-[calc(100vh-300px)] min-h-[500px] font-mono text-sm p-4 border border-gray-200 rounded-lg bg-gray-50 overflow-auto whitespace-pre-wrap">
          {note}
        </pre>
      )}
    </div>
  );
}
